import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import MLink from '@material-ui/core/Link';

const InlineMarkdown = (props) => {
  return (
    <ReactMarkdown
      components={{
        a: function LinkRenderer(node) {
          return <MLink {...node} rel="noopener noreferrer" />;
        },
      }}
      disallowedElements={['p']}
      remarkPlugins={[
        remarkGfm,
      ]}
      unwrapDisallowed
      {...props}
    />
  );
};

export default InlineMarkdown;
